import { useBootstrap } from '@/auth/bootstrap-context';
import { isCloudSyncPaused } from '@/store/read-only-guard';
/**
 * Whether cloud sync is currently paused for this user (subscription expired / revoked / past-due)
 * while CloudBound data still exists — so the UI can show a banner and go read-only.
 */
export function useCloudSyncPaused() {
    const { data } = useBootstrap();
    const status = data?.cloudSyncStatus;
    return { paused: isCloudSyncPaused(status), reasonCode: status?.reasonCode ?? null };
}
